import { Navigate, useLocation } from "react-router-dom";

interface LegacyRedirectProps {
  from: "advisories" | "vulnerabilities" | "checks";
  type: "ADVISORY" | "CVE" | "CHECK";
}

export function LegacyRedirect({ from, type }: LegacyRedirectProps) {
  const { pathname, search } = useLocation();

  // Replace the trailing legacy segment with /findings
  const newPathname = pathname.replace(new RegExp(`/${from}/?$`), "/findings");

  // Preserve existing params; only set type if not present
  const params = new URLSearchParams(search);
  if (!params.has("type")) params.set("type", type);

  const qs = params.toString();
  return <Navigate to={`${newPathname}${qs ? `?${qs}` : ""}`} replace />;
}
